var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6317 12.3244C53.0117 -3.29562 27.6837 -3.29562 12.0637 12.3244C-3.55768 27.947 -3.55768 53.2724 12.0637 68.895C27.6837 84.515 53.0117 84.515 68.6317 68.895C84.253 53.2724 84.253 27.947 68.6317 12.3244ZM57.681 52.7857L47.5677 42.9004L29.6237 60.6084L20.3477 51.215L37.9717 33.3604L28.181 23.275H57.681V52.7857Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.8dcefce3cb48ac18fbf5b59ba31a6196.svg";
export { ForwardRef as ReactComponent };